import React from 'react'
import clsx from 'clsx'
import shallow from 'zustand/shallow'
import { withStyles, Switch } from '@material-ui/core'

// Styles for this component.
const styles = theme => ({
  root: {
    // styles borrowed from AntSwitch example
    // https://mui.com/components/switches/
    width: 28,
    height: 16,
    padding: 0,
    marginRight: theme.spacing(1),
    display: 'inline-flex',
    // '& :not(.Mui-focusVisible)': {
    '&:focus-within': {
      // '& .MuiSwitch-thumb:after': {},
      '& .MuiSwitch-track': {
        border: '2px solid',
        borderColor:
          theme.extras.variables.colors.ddkMainBlue,
      },
    },
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor:
            theme.extras.variables.colors.pictonBlue,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
  },
})

const SwitchControl = ({
  classes,
  checked,
  onChange,
  className,
  ...props
}) => {
  return (
    <Switch
      className={clsx(
        classes.root,
        'switch-control',
        className,
      )}
      checked={checked}
      onChange={onChange}
      color="primary"
    />
  )
}

export default withStyles(styles)(SwitchControl)
